
import { AuthTenantTypeEnum } from "@/models/AuthTenant";
import { Organization } from "@/models/Organization";
import { IMovitInstance } from "@/typings/timit";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import vuetifyToast from "vuetify-toast";

interface ICreateAuthTenant {
  externalTenantId: string;
  type: number;
  name: string; 
  organizationId: string;
}

@Component({
  components: {},
})
export default class AddTenantDialog extends Vue {
  authTenantIsValid: boolean = false;

  newAuthTenant: ICreateAuthTenant = {
    externalTenantId: "",
    type: AuthTenantTypeEnum.AzureAD,
    name: "",
    organizationId: "",
  };

  rules: any = {
    required: (val) =>
      !!val || this.$i18n.translate("validation.rules.required", "Required")
  };

  instances: IMovitInstance[] = [];

  @Prop({ default: false }) open: boolean;
  @Prop({ default: null }) organizationId: string | null;

  @Watch("organizationId", { immediate: true })
  async setOrganizationId() {
    this.newAuthTenant.organizationId = this.organizationId;
  }

  async createAuthTenant() {
    try {
      const result = await this.$store.dispatch(
        "organization/createAuthTenant",
        { data: this.newAuthTenant }
      );

      // const organization: Organization = this.$store.state.organization.organizations
      //   .find(o => o.id === this.newAuthTenant.organizationId);

      // const newAuthTenant = organization.authTenants.find(d => d.id === result.data.id);

      // this.$store.commit("organization/addAuthTenant", newAuthTenant);

      vuetifyToast.success(
        this.$i18n.translate(
          "organization.authTenant.create.success",
          "Tenant added."
        )
      );
      this.closeEditor();
    } catch (error) {
      vuetifyToast.error(
        this.$i18n.translate(
          "organization.authTenant.create.error",
          "Adding tenant failed: {errorMessage}",
          {
            errorMessage: error,
          }
        )
      );
    }
  }

  closeEditor() {
    this.emptyForm();
    this.$emit("close");
  }

  emptyForm() {
    this.newAuthTenant.externalTenantId = "";
    this.newAuthTenant.type = AuthTenantTypeEnum.AzureAD;
    this.newAuthTenant.name = "";
    (this.$refs.form as any).resetValidation();
  }
}
